import { Component, input } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { CurrentSort } from '../../services/table-sort.service'

@Component({
  imports: [MatIcon],
  selector: '[app-table-header-sort-indicator]',
  template: `
        @if (currentSort()) {
            @if (currentSort()?.direction === 'desc') {
                <mat-icon svgIcon="sort_desc"/>
            } @else {
                <mat-icon svgIcon="sort_asc"/>
            }

            @if (currentSort()?.order) {
                <span class="order-indicator">{{ currentSort()?.order }}</span>
            }
        }
    `,
  styles: `
        :host {
          position: relative;
          width: 1.5rem;
          height: 1.5rem;
          .mat-icon {
            transform: scale(0.75);
          }
        }

        .order-indicator {
            position: absolute;
            bottom: -0.25rem;
            left: 0.85rem;
            font-size: 0.75rem;
            line-height: 1rem;
            min-width: 1rem;
            padding: 0 0.25rem;
            border-radius: 0.5rem;
            background-color: var(--active-blue);
            color: white;
            z-index: 0;
        }
    `,
})
export class TableHeaderSortIndicatorComponent {
  currentSort = input<CurrentSort>()
}